import React from "react";
import type { AppProps } from "next/app";
import Head from "next/head";

// Global CSS from node_modules — Next.js requires these in _app.tsx
import "rc-tooltip/assets/bootstrap_white.css";
import "@deliverr/react-select-v1/dist/react-select.css";
import "react-calendar/dist/Calendar.css";

const isProd = process.env.ENV === "production";
const pageTitle = isProd ? "Flexport Seller Portal" : `(${process.env.ENV ?? "development"}) Flexport Seller Portal`;

export default function SellerPortalApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{pageTitle}</title>
      </Head>
      <Component {...pageProps} />
    </>
  );
}
